import { CrashReporter } from "./crash_reporter.js";

CrashReporter.install();
